const siteUrl = import.meta.env.VITE_SITE_URL || 'https://botan-buy.com';

const storeSchema = {
  '@context': 'https://schema.org',
  '@type': 'Store',
  '@id': `${siteUrl}/mangaku#store`,
  name: 'カードショップ まんがく',
  alternateName: 'まんがく 高松 ポケモンカード',
  description: '香川県高松市のトレーディングカード専門店。ポケモンカード・ワンピースカード・ユニオンアリーナ・デュエルマスターズ・ヴァイスシュバルツの買取・販売。',
  url: `${siteUrl}/mangaku`,
  telephone: '+81-92-577-9739',
  email: 'info@botan-buy.com',
  image: 'https://public.readdy.ai/ai/img_res/11d31c13fbaf1067acf26eff622421b4.jpg',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '瓦町2-1-28 高尾ビル2F南',
    addressLocality: '高松市',
    addressRegion: '香川県',
    postalCode: '760-0023',
    addressCountry: 'JP',
  },
  geo: { '@type': 'GeoCoordinates', latitude: 34.3401, longitude: 134.0434 },
  openingHoursSpecification: [
    { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'], opens: '10:00', closes: '19:00' },
  ],
  areaServed: [
    { '@type': 'AdministrativeArea', name: '香川県' },
    { '@type': 'AdministrativeArea', name: '高松市' },
  ],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: '取扱カードゲーム',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Product', name: 'ポケモンカードゲーム 買取・販売' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Product', name: 'ワンピースカードゲーム 買取・販売' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Product', name: 'ユニオンアリーナ 買取・販売' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Product', name: 'デュエルマスターズ 買取・販売' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Product', name: 'ヴァイスシュバルツ 買取・販売' } },
    ],
  },
  parentOrganization: { '@type': 'Organization', name: '株式会社BotaN', url: `${siteUrl}/` },
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'ホーム', item: `${siteUrl}/` },
    { '@type': 'ListItem', position: 2, name: 'カードショップ まんがく', item: `${siteUrl}/mangaku` },
  ],
};

export default function MangakuSeoJsonLd() {
  return (
    <>
      {[storeSchema, breadcrumbSchema].map((schema, i) => (
        <script key={i} type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      ))}
    </>
  );
}
